<template>
  <div class="cont">

      <div class="form-wrap">
        <el-input class="input mgr10" v-model="keyword" placeholder="请输入内容" clearable></el-input>
        <el-select class="select mgr10" v-model="type" placeholder="请选择状态">
            <el-option v-for="(item, idx) in items" 
            :key="idx" :label="item.label" :value="item.val"></el-option>
        </el-select>

        <el-date-picker
            class="picker mgr10"
            v-model="value1"
            type="daterange"
            :clearable="true"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>

        <el-button type="danger" @click="init">搜索</el-button>
      </div>

      <div>
        <el-table
        v-loading = "pictLoading"
        :empty-text="$t('noData')"
        :data="tableData"
        style="width: 100%">
            <el-table-column
                label=""
                width="100">
                <template slot-scope="scope">
                    <div class="icons">
                        <img class="table-icon" v-if="scope.row.type == 2" src="@/assets/images/channel/settled.png" alt="">
                        <img class="table-icon" v-else src="@/assets/images/channel/unsettled.png" alt="">
                    </div>
                </template>
            </el-table-column>
            <el-table-column  width="180" prop="money" label="佣金提现"  > </el-table-column>
            <el-table-column prop="nickname" label="用户" ></el-table-column>
            <el-table-column  prop="ctime" label="时间" > </el-table-column>
            <el-table-column  prop="type_name"  label="状态" > </el-table-column>
        </el-table>
      </div>

      <Pagination
        :totalPage="totalPage"
        :limit="10"
        @changePage="handleCurrentChange"
      ></Pagination>

        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="title"> {{currentUser.nickname}}的佣金提现审核：{{currentUser.money}}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="agree">同 意</el-button>
            </span>
        </el-dialog>

  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
export default {
    components: {
        Pagination
    },
    data() {
        return {
            items: [
                {label: "全部",     val: ''},
                {label: "未结算",   val:'1'},
                {label: "已结算",   val:'2'}
            ],
            pictLoading: true,
            tableData: [],
            totalPage: 1,
            form: {
                limit: 10,
                page: 1
            },
            value1: '',
            type: '',
            keyword: '',
            dialogVisible: false,
            currentUser: {},
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        type() {
            this.form.page = 1
        }
    },
    methods: {
        
        agree() {
            const _this = this
            this.$api.examine({type: 2, id: this.currentUser.id}).then( res => {
                this.$message({
                    message:  res.status ? (res.msg || '成功') : '失败',
                    type: res.status ? 'success' : 'error'
                })
                if(res.status) {
                    _this.dialogVisible = false
                    _this.init()
                }
            })
        },
        handleClick(v) {
            this.dialogVisible = true
            this.currentUser = v
        },
        handleCurrentChange(v) {
            this.form.page = v
            this.init()
        },
        init() {
            this.pictLoading = true
            let form = {...this.form}
            this.keyword && (form.keyword   = this.keyword)
            this.type    && (form.type      = this.type)
            if(this.value1) {
                form.start_date      = this.value1[0]
                form.end_date        = this.value1[1]
            }
            this.$api.withdrawallist(form).then(res =>{
                if(res.status) {
                    this.tableData = res.data
                    this.totalPage = res.total
                }
                this.pictLoading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.mgr10 {
    margin-right: 10px;
}
.table-icon {
    width: 30px;
    height: 30px;
}
.title {
    text-align: center;
    margin-top: 40px;
    margin-bottom: 20px;
}
.icons {
    display: flex;
    align-items: center;
}
.cont {
    // width: 700px;
}
.form-wrap{
    display: flex;
    align-items: center;
    .input {
        width: 300px;
    }
}
</style>